export default "__VITE_ASSET__CPRViFsE__"